import { Breadcrumbs, Typography, Stack, TablePagination, Link } from "@mui/material";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import RefreshButton from "../../../../../common/components/refresh_button";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import { GenerateProjetoImpressaoColumnDefinition } from "./columns";
import { Header } from "./components/header";
import { BackButton } from "../../../../../common/components/back_button";
import { useImpressaoListaGerenciarViewModel } from "../../viewModels/impressao_listagerenciar_view_model";
import { SendMailModal } from "../../../../../common/components/send_email_modal";

export const Impressao_listagerenciar = () => {

  const viewModel = useImpressaoListaGerenciarViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateProjetoImpressaoColumnDefinition({
      onActionEditar: viewModel.handleEdit,
      onActionSendEmail: viewModel.handleEmailOpenState,
    });
  }, [
    viewModel.handleEdit,
    viewModel.handleEmailOpenState,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <BackButton onClick={() => window.history.back()} />
            </div>
          }
        />
      </PageTopBar>

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit">
            Projetos
          </Link>
          <Typography className="text-primary-green">Gerenciar Solicitação de Impressão</Typography>
        </Breadcrumbs>

        <div className="flex gap-2 items-center w-full">
          <h1 className="text-3xl font-medium text-black dark:text-white">Gerenciar Solicitações de Impressão</h1>
          <RefreshButton onClick={() => viewModel.handleClear()} />
        </div>

        <Header
          ddlCentroCusto={viewModel.ddlCentroCusto}
          ddlProjeto={viewModel.ddlProjeto}
          ddlSolicitante={viewModel.ddlFuncionario}
          idsCentroCusto={viewModel.filters.idsCentroCusto}
          idsProjeto={viewModel.filters.idsProjeto}
          idsSolicitante={viewModel.filters.idsSolicitante}
          statusOptions={viewModel.ddlStatus}
          statusEmailOptions={viewModel.ddlStatusEmail}
          status={viewModel.filters.status ?? undefined}
          statusEmail={viewModel.filters.statusEmail ?? undefined}
          dataDe={viewModel.filters.dataDe}
          dataAte={viewModel.filters.dataAte}
          onCentroCustoChange={viewModel.handleCentroCustoChange}
          onProjetoChange={viewModel.handleProjetoChange}
          onSolicitanteChange={viewModel.handleSolicitanteChange}
          onStatusChange={viewModel.handleStatusChange}
          onStatusEmailChange={viewModel.handleStatusEmailChange}
          onDataChange={viewModel.handleDataChange}
          onClearFilters={viewModel.handleClear}
        />

        <Stack spacing={0}>
          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
          />

          <StyledDataGrid
            tableName="ProjetoImpressao"
            disableColumnMenu={false}
            showToolbar
            disableRowSelectionOnClick
            getRowId={(row: any) => row.idProjetoImpressao}
            columns={columnsDefinition}
            loading={viewModel.loading}
            rows={viewModel.listaImpressao ?? []}
            rowCount={viewModel.pagination.totalItems}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page - 1,
              pageSize: viewModel.pagination.rowsPerPage,
            }}
            pinnedColumns={{
              right: ['idProjetoImpressao'],
            }}
            getRowHeight={() => 'auto'}
          />

          <TablePagination
            component="div"
            count={viewModel.pagination.totalItems}
            page={viewModel.pagination.page - 1}
            onPageChange={(_, p) => viewModel.handlePageChange(p)}
            rowsPerPageOptions={[10, 25, 50, 100]}
            rowsPerPage={viewModel.pagination.rowsPerPage}
            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
          />
        </Stack>

      </div>

      <SendMailModal
        open={viewModel.openEmailModal}
        loading={viewModel.loading}
        sendTo={viewModel.emailSendTo}
        subject={viewModel.emailSubject}
        attachment={viewModel.emailAttachment}
        body={viewModel.emailBody}
        onClose={() => viewModel.handleEmailOpenState(null, false)}
        onSubmit={viewModel.handleEmailSubmit}
      />


    </>
  );
};
